import { TableCell, Typography } from '@mui/material';

import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

import StyledTableRow from './styles';

const LegendItem = ({ series }: { series: ExtendedSeriesOptionsType }) => {
  const context = series?.custom;
  if (!context) return null;
  return (
    <StyledTableRow
      key={series.name + context.field}
      sx={{ '&:last-child': { borderBottom: 0 } }}
    >
      <TableCell sx={{ pr: 5 }}>
        <Typography variant='body2'>{context.Title}</Typography>
      </TableCell>
      <TableCell
        align='left'
        sx={{ pr: 5 }}
        width={110}
      >
        <Typography variant='body2'>{context.Alias}</Typography>
      </TableCell>
      <TableCell
        align='left'
        sx={{ pr: 5 }}
        width={110}
      >
        <Typography variant='body2'>{context.Code}</Typography>
      </TableCell>
      <TableCell
        align='right'
        sx={{ pr: 5 }}
        width={80}
      >
        <Typography variant='body2'>{context.Currency}</Typography>
      </TableCell>
      <TableCell
        align='right'
        width={80}
      >
        <Typography variant='body2'>{context.Units}</Typography>
      </TableCell>
    </StyledTableRow>
  );
};

export default LegendItem;
